import { filterMenuDialogId } from '~/app/features/Gallery/components/Header/ActionHeader/components/FilterMenu/constants'

export const isFilterModalHidden = (): boolean => !document.getElementById(filterMenuDialogId)?.hasAttribute('open')
